export default __webpack_public_path__ + "static/media/logo.a48d34c3.svg";